<h2 mat-dialog-title class="flex items-center gap-2 text-lg font-bold">
  <mat-icon class="text-primary">group</mat-icon>
  <span>Colaboradores de ruta</span>
</h2>

<mat-dialog-content class="p-6">
  <!-- Formulario de Creación -->
  <div class="mb-6 bg-white rounded-lg border border-gray-200 shadow-sm">
    <div class="flex items-center gap-3 px-4 py-3 border-b border-blue-100 bg-blue-50">
      <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-500 flex items-center justify-center">
        <mat-icon class="text-white">person_add</mat-icon>
      </div>
      <h3 class="text-lg font-semibold text-gray-800">Agregar Colaborador</h3>
    </div>

    <div class="p-4">
      <form [formGroup]="collaboratorForm" class="flex flex-col gap-4">
        <!-- Socio de Negocio (Autocomplete) -->
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Socio de Negocio</mat-label>
          <input
            type="text"
            matInput
            [formControl]="businessPartnerSearchControl"
            [matAutocomplete]="autoBusinessPartner"
            placeholder="Escribe para buscar..."
            autocomplete="off">
          <mat-icon matSuffix *ngIf="!isLoadingBusinessPartners">search</mat-icon>
          <mat-spinner matSuffix *ngIf="isLoadingBusinessPartners" diameter="20"></mat-spinner>
          <mat-autocomplete
            #autoBusinessPartner="matAutocomplete"
            [displayWith]="displayBusinessPartner.bind(this)"
            (optionSelected)="onBusinessPartnerSelected($event.option.value)">
            <mat-option *ngFor="let bp of filteredBusinessPartners$ | async" [value]="bp">
              <!-- Flex container para contenido + botón -->
              <div class="flex items-center justify-between w-full gap-3">

                <!-- Información del Business Partner -->
                <div class="flex items-center gap-2 flex-1 min-w-0">
                  <mat-icon class="text-blue-600 flex-shrink-0">business</mat-icon>
                  <div class="flex flex-col flex-1 min-w-0">
                    <span class="font-semibold truncate">{{ bp.name }}</span>
                    <span class="text-xs text-gray-500">{{ bp.externalKeys?.code || bp.id }}</span>
                  </div>
                </div>

                <!-- Botón de navegación -->
                <button
                  *ngIf="isBusinessPartnerNavigable(bp)"
                  mat-icon-button
                  color="primary"
                  (click)="navigateToBusinessPartner(bp, $event)"
                  [matTooltip]="getNavigationTooltip()"
                  matTooltipPosition="left"
                  class="flex-shrink-0 nav-button">
                  <mat-icon class="icon-size-5">launch</mat-icon>
                </button>
              </div>
            </mat-option>
          </mat-autocomplete>
          <mat-hint *ngIf="!isLoadingBusinessPartners && !businessPartnerSearchControl.value">
            Escribe para buscar socios de negocio
          </mat-hint>
          <mat-error *ngIf="businessPartnerIdControl.hasError('required')">
            El socio de negocio es obligatorio
          </mat-error>
        </mat-form-field>

        <!-- Función (Autocomplete) -->
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Función</mat-label>
          <input
            type="text"
            matInput
            [formControl]="functionSearchControl"
            [matAutocomplete]="autoFunction"
            placeholder="Escribe para buscar..."
            autocomplete="off">
          <mat-icon matSuffix *ngIf="!isLoadingFunctions">search</mat-icon>
          <mat-spinner matSuffix *ngIf="isLoadingFunctions" diameter="20"></mat-spinner>
          <mat-autocomplete
            #autoFunction="matAutocomplete"
            [displayWith]="displayFunction.bind(this)"
            (optionSelected)="onFunctionSelected($event.option.value)">
            <mat-option *ngFor="let func of filteredFunctions$ | async" [value]="func">
              <div class="flex items-center gap-2">
                <mat-icon class="text-indigo-600">badge</mat-icon>
                <div class="flex flex-col">
                  <span class="font-semibold">{{ func.name }}</span>
                  <span class="text-xs text-gray-500">{{ func.code }}</span>
                </div>
              </div>
            </mat-option>
          </mat-autocomplete>
          <mat-hint *ngIf="!isLoadingFunctions && !functionSearchControl.value">
            Escribe para buscar funciones
          </mat-hint>
          <mat-error *ngIf="functionIdControl.hasError('required')">
            La función es obligatoria
          </mat-error>
        </mat-form-field>

        <!-- Botón Guardar -->
        <div class="flex justify-end">
          <button
            mat-raised-button
            color="primary"
            (click)="onSaveNewCollaborator()"
            [disabled]="collaboratorForm.invalid"
            class="px-6">
            <mat-icon class="mr-2">add</mat-icon>
            Agregar Colaborador
          </button>
        </div>
      </form>
    </div>
  </div>

  <mat-divider class="my-6"></mat-divider>

  <!-- Lista de Colaboradores -->
  <div class="collaborators-list">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-semibold text-gray-700">
        Colaboradores Asignados
        <span class="ml-2 text-sm font-normal text-gray-500">
          ({{ listCollaboratorsAdd.length }})
        </span>
      </h3>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoadingCollaborators" class="flex flex-col items-center justify-center py-12">
      <mat-spinner diameter="50"></mat-spinner>
      <p class="mt-4 text-gray-500">Cargando colaboradores...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoadingCollaborators && listCollaboratorsAdd.length === 0"
         class="flex flex-col items-center justify-center py-12 bg-gray-50 rounded-lg">
      <mat-icon class="text-gray-300" style="font-size: 64px; width: 64px; height: 64px;">
        person_off
      </mat-icon>
      <p class="mt-4 text-gray-500 text-center">
        No hay colaboradores asignados a esta sub-ruta
      </p>
      <p class="text-sm text-gray-400">
        Agregue colaboradores usando el formulario superior
      </p>
    </div>

    <!-- Cards List -->
    <div *ngIf="!isLoadingCollaborators && listCollaboratorsAdd.length > 0"
         class="flex flex-col gap-3">

      <div *ngFor="let collab of listCollaboratorsAdd; let i = index"
           class="collab-card flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow">

        <!-- Avatar/Icon -->
        <div class="flex-shrink-0">
          <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
            <mat-icon class="text-blue-600">person</mat-icon>
          </div>
        </div>

        <!-- Info -->
        <div class="flex-grow min-w-0">
          <div class="font-semibold text-gray-900 truncate">
            {{ collab.businessPartner?.name || collab.username || 'Colaborador sin nombre' }}
          </div>
          <div class="text-sm text-gray-600 flex items-center gap-2 mt-1">
            <mat-icon class="text-gray-400" style="font-size: 16px; width: 16px; height: 16px;">
              badge
            </mat-icon>
            <span>{{ collab.businessPartnerFunction?.name || 'Sin función' }}</span>
          </div>
          <div *ngIf="collab.businessPartner?.externalKeys?.code"
               class="text-xs text-gray-500 mt-1">
            Código: {{ collab.businessPartner.externalKeys.code }}
          </div>
        </div>

        <!-- Status Toggle -->
        <div class="flex-shrink-0">
          <mat-slide-toggle
            [checked]="collab.statusId === StatusEnum.ACTIVE"
            (change)="onStatusChange($event.checked, collab)"
            color="primary">
            <span class="text-sm">
              {{ collab.statusId === StatusEnum.ACTIVE ? 'Activo' : 'Inactivo' }}
            </span>
          </mat-slide-toggle>
        </div>

        <!-- Actions -->
        <div class="flex-shrink-0 flex gap-2">
          <!-- Navigation Button -->
          <button
            *ngIf="isBusinessPartnerNavigable(collab.businessPartner)"
            mat-icon-button
            color="primary"
            (click)="navigateToBusinessPartner(collab.businessPartner, $event)"
            [matTooltip]="getNavigationTooltip()">
            <mat-icon>launch</mat-icon>
          </button>

          <!-- Edit Function Button -->
          <button
            mat-icon-button
            color="accent"
            (click)="openEditFunctionModal(collab)"
            matTooltip="Editar función">
            <mat-icon>edit</mat-icon>
          </button>

          <!-- Delete Button -->
          <button
            mat-icon-button
            color="warn"
            (click)="onDeleteToListCollaborator(collab)"
            matTooltip="Eliminar">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end gap-3 p-4 bg-gray-50">
  <button mat-button mat-dialog-close>
    <mat-icon class="mr-2">close</mat-icon>
    Cerrar
  </button>
</mat-dialog-actions>
